import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";

export const featuredDealsSlice = createSlice({
	name: "featured-deals",
	initialState,
	reducers: {
		setSelectedDealIndex: (state, action: PayloadAction<number | null>) => {
			state.selectedDealIndex = action.payload;
		}
	}
});

export const { setSelectedDealIndex } = featuredDealsSlice.actions;

export default featuredDealsSlice.reducer;
